module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    import IMeevoMessengerSettings = Meevo.Model.IMeevoMessengerSettings;
    import IMeevoMessengerAutoReply = Meevo.Model.IMeevoMessengerAutoReply;
    import MeevoMessengerAutoRepliesEnum = Meevo.Model.MeevoMessengerAutoRepliesEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export interface IMeevoMessengerSettingsClientsAppSection extends Meevo.Components.CommonClasses.ICommonSection {
        edit: () => void,
        initializeHeader: () => void
    }

    export class ClientAppSection extends Meevo.Components.CommonClasses.CommonSectionBase implements IMeevoMessengerSettingsClientsAppSection {
        public params: ISectionParamsMeevoMessengerSettings;
        public model: any; // TODO: add type
        public firebaseConfig: string;
        public isHasAccess = false;
        public employeesCriteria = {
            showEmployeesOnly: true,
            includeActive: true,
            includeInactive: true,
            iIncludeDeleted: true
        };

        public isEditingMessaging: boolean = false;
        public autoReplies: IMeevoMessengerAutoReply[] = [
            { type: MeevoMessengerAutoRepliesEnum.DefaultAutoReplyMessage, name: 'LABEL_AWAY_FROM_DESK', editingLabel: 'LABEL_MEEVO_MESSENGER_DEFAULT_AUTO_REPLY_MESSAGE', default: 'TEXT_MEEVO_MESSENGER_DEFAULT_AUTOREPLY_MESSAGE' },
            { type: MeevoMessengerAutoRepliesEnum.HolidayAutoReplyMessage, name: 'LABEL_CLOSED_FOR_HOLIDAY', editingLabel: 'LABEL_MEEVO_MESSENGER_HOLIDAY_AUTO_REPLY_MESSAGE', default: 'TEXT_MEEVO_MESSENGER_CLOSED_FOR_HOLIDAY_MESSAGE' },
            { type: MeevoMessengerAutoRepliesEnum.OutsideHoursAutoReplyMessage, name: 'LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS', editingLabel: 'LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS_AUTO_REPLY_MESSAGE', default: 'TEXT_MEEVO_MESSENGER_AFTER_HOURS_MESSAGE' }
        ];
        public quickResponse: any[] = [
            { orderNumber: 0, displayName: 'TEXT_NAME_MEEVO_MESSENGER_WAIT_QUICK_RESPONSE', body: 'TEXT_MEEVO_MESSENGER_WAIT_QUICK_RESPONSE' },
            { orderNumber: 1, displayName: 'TEXT_NAME_MEEVO_MESSENGER_READY_QUICK_RESPONSE', body: 'TEXT_MEEVO_MESSENGER_READY_QUICK_RESPONSE' }
        ];

        constructor(
            params: ISectionParamsMeevoMessengerSettings,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected meevoMessengerSettingsService: IMeevoMessengerSettingsService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $scope: angular.IScope,
            protected $q: angular.IQService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey);

            this.params = params;

            this.checkKey();
        }

        initializeHeader() {
            if (this.model.quickAnswers.length == 0) {
                this.quickResponse.forEach(quick => {
                    quick.displayName = this.$translate.instant(quick.displayName);
                    quick.body = this.$translate.instant(quick.body);
                    this.model.quickAnswers.push(quick);
                });
            }


            this.model.quickAnswers = this.$filter('orderBy')(this.model.quickAnswers, 'orderNumber');
            this.autoPopulateQuickReply();

            this.autoReplies = this.autoReplies.map((autoReply: IMeevoMessengerAutoReply) => {
                Object.defineProperty(autoReply, 'body', {
                    get: () => { return this.model[this.autoReplyPropertyName(autoReply.type)]; },
                    set: (newValue: string) => { this.model[this.autoReplyPropertyName(autoReply.type)] = newValue; }
                });
                return autoReply;
            });
        }

        preSave(): void {
            this.autoPopulateQuickReply();
            this.endEditingMessaging();
            this.model.classification = 'ClientApp'; //todo: move this to the initial Setup
            // Categories ids from the smart mover
            delete this.model.userCategoriesIdsList;
        }

        edit() {
            this.startEditingMessaging();
        }

        rollbackChanges() {
            super.rollbackChanges();
            this.endEditingMessaging();
        }

        saveFirebase() {
            this.meevoMessengerSettingsService.megoCustomApp(this.firebaseConfig);
        }

        isMSIUser() {
            return this.identityService.current().userTypeEnum === Model.UserTypeEnum.MSIUser;
        }

        private checkKey() {
            this.securityChecker.checkSecurityKey('INTEGRATION:CUSTOMBRANDEDAPP:READ').then(resp => {
                this.isHasAccess = resp === SecurityAccessEnum.Grant;
            })
        }

        private autoPopulateQuickReply(): void {
            this.autoReplies.forEach(autoReply => {
                let propertyName = this.autoReplyPropertyName(autoReply.type);
                if (!this.model[propertyName]) {
                    this.model[propertyName] = this.$translate.instant(autoReply.default);
                }
            });
        }

        private autoReplyPropertyName(type: MeevoMessengerAutoRepliesEnum): string {
            let propertyName = MeevoMessengerAutoRepliesEnum[type];
            // Set first letter to lower case
            return propertyName.charAt(0).toLowerCase() + propertyName.substr(1);
        }

        private startEditingMessaging(): void {
            this.isEditingMessaging = true;
        }

        private endEditingMessaging(): void {
            this.isEditingMessaging = false;
        }
    }
}
